import { Action } from 'redux/action';

export const createAction = <T, D>(type: T, data?: D): Action<T, D> => ({
  type: type,
  data: data,
});
